module.exports = __webpack_public_path__ + "img/bg-right.ff72f75f.png";